var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-id-time",class:{'is-first': _vm.isFirst, 'no-others': !_vm.others}},[_c('EventId',{attrs:{"event-id":_vm.eventId,"dark":!_vm.others}}),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.getTime))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }